import React from 'react'
import {Link,NavLink} from 'react-router-dom'
import "../styles/sidebar.css";
import logo4 from "../logo4.png";
import logoText2 from "../logoText2.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome,faUser,faEnvelope,faRocket,faBlog,faTimeline } from '@fortawesome/free-solid-svg-icons'
import useHover from '../Hooks/useHover';


// npm i --save @fortawesome/free-brands-svg-icons
// import { faGithub,faInstagram } from '@fortawesome/free-brands-svg-icons'
import {
    faInstagram,
    faGithub,
    faDev
  } from '@fortawesome/free-brands-svg-icons'

function Sidebar() {
    const [flag1,onHover1] = useHover(false);
    const [flag2,onHover2] = useHover(false);
    const [flag3,onHover3] = useHover(false);
    const [flag4,onHover4] = useHover(false);
    const [flag5,onHover5] = useHover(false);
    const [flag6,onHover6] = useHover(false);

    

    return (
        <div className="sidebar" >
            <Link to="/">
                <img src={logo4} alt="Logo" className="logo"/>
            </Link>
            <Link to="/">
                <img src={logoText2} alt="LogoText" className="logoText"/>
            </Link>
            <nav>
                <NavLink to="/"   >

                { flag1? <span  onMouseOut={onHover1}>HOME</span>:
                    <FontAwesomeIcon icon={faHome} className="nav-Home" onMouseEnter={onHover1} />}
                </NavLink>
             <NavLink to="/projects">
                { flag2?  <span onMouseOut={onHover2}>PROJECTS</span> :
                <FontAwesomeIcon icon={faRocket} className="nav-Project" onMouseOver={onHover2}  />}
                </NavLink>
                <NavLink to="/about"   >
                { flag3?  <span  onMouseOut={onHover3}>ABOUT</span> :
                <FontAwesomeIcon icon={faUser} className="nav-About" onMouseOver={onHover3}/>}
                </NavLink>
                <NavLink to="/contact"    >
                { flag4?  <span onMouseOut={onHover4}>CONTACT</span> :
                <FontAwesomeIcon icon={faEnvelope} className="nav-Contact" onMouseOver={onHover4}/>}
                </NavLink>
               
                <NavLink to="/blogs">
                { flag5?  <span onMouseOut={onHover5}>BLOGS</span> :
                <FontAwesomeIcon icon={faBlog} className="nav-Contact" onMouseOver={onHover5}/>}
                </NavLink>
                <NavLink to="/timeline">
                { flag6?  <span onMouseOut={onHover6}>TIMELINE</span> :
                <FontAwesomeIcon icon={faTimeline} className="nav-Contact" onMouseOver={onHover6}/>}
                </NavLink>
            </nav>

            <ul className='siderbar__ul'>
                <li><a href="https://github.com/Jayant818" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faGithub}/>
                    </a></li>
                <li><a href="https://www.instagram.com/web.developer.io/" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faInstagram}/>
                    </a></li>
                <li><a href="https://dev.to/jay818" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faDev}/>
                    </a></li>
            </ul>
        </div>
    )
}

export default Sidebar
